var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { TabbedShowLayout, useRecordContext } from "react-admin";
import ElectionHeader from "../../components/ElectionHeader";
import { EditContestData } from "./EditContestData";
import { ListTallySheet } from "../TallySheet/ListTallySheet";
import { TallySheetWizard, WizardSteps } from "../TallySheet/TallySheetWizard";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
export var ContestTabs = function () {
    var aliasRenderer = useAliasRenderer();
    var record = useRecordContext();
    var _a = useState(WizardSteps.List), action = _a[0], setAction = _a[1];
    var _b = useState(null), refresh = _b[0], setRefresh = _b[1];
    var _c = useState(), tallySheetId = _c[0], setTallySheetId = _c[1];
    var handleAction = function (action, id) {
        setAction(action);
        setRefresh(new Date().getTime().toString());
        if (id) {
            setTallySheetId(id);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: aliasRenderer(record), subtitle: "contestScreen.common.subtitle" }), _jsxs(TabbedShowLayout, { children: [_jsx(TabbedShowLayout.Tab, __assign({ label: "Data" }, { children: _jsx(EditContestData, {}) })), _jsx(TabbedShowLayout.Tab, __assign({ label: "Tally Sheets", onClick: function () {
                            setAction(WizardSteps.List);
                        } }, { children: record &&
                            (action === WizardSteps.List ? (_jsx(ListTallySheet, { contest: record, doAction: handleAction, reload: refresh })) : action === WizardSteps.Start ? (_jsx(TallySheetWizard, { contest: record, action: action, doAction: handleAction })) : action === WizardSteps.Edit ? (_jsx(TallySheetWizard, { tallySheetId: tallySheetId, contest: record, action: action, doAction: handleAction })) : action === WizardSteps.Confirm ? (_jsx(TallySheetWizard, { tallySheetId: tallySheetId, contest: record, action: action, doAction: handleAction })) : action === WizardSteps.View ? (_jsx(TallySheetWizard, { tallySheetId: tallySheetId, contest: record, action: action, doAction: handleAction })) : null) }))] })] }));
};
